import {
  Encrypt,
  Enrutador,
  Environment,
  MicrofrontendDinamic,
} from '@his-sinergia/lib-utils'

export const environment: Environment = {
  atmosphere: 'qa',
  production: false,
  url: 'https://qa-v2.alehis.com/',
  SECRET_KEY: 'Ber1g0',
  token: '',
}

export const enrutador: Enrutador = {
  url: 'parametros/',
  urlFiles: 'files/',
  urlAdmisiones: 'admisiones/',
  urlLogin: 'security/',
  urlImpresiones: 'impresiones/',
  urlListas: 'listas/',
  urlAgenda: 'agenda/',
  urlTercero: 'terceros/',
  urlSede: 'sedes/',
  urlInventario: 'inventario/',
  urlOdontology: 'odontologia/',
  urlTransversales: 'transversales/',
  urlFinanzas: 'financial/',
}

export const microfrontend: MicrofrontendDinamic = {
  mfTranservales: {
    remoteEntryUrl:
      'https://qa-v2.alehis.com/mf-transversales/remoteEntry.json',
    componentMedicalNote: {
      exposedModule: './MedicalNotesComponent',
      componentName: 'MedicalNotesComponent',
      customElementName: 'medical-notes-artifact',
      componentId: 274,
      dynamicFormTypeId: 0,
    },
    componentDisabilities: {
      exposedModule: './DisabilitiesComponent',
      componentName: 'DisabilitiesComponent',
      customElementName: 'disabilities-artifact',
      componentId: 279,
      dynamicFormTypeId: 0,
    },
    componentNursingNotes: {
      exposedModule: './NursingNotesComponent',
      componentName: 'NursingNotesComponent',
      customElementName: 'nursing-notes-artifact',
      componentId: 484,
      dynamicFormTypeId: 0,
    },
    componentOrdination: {
      exposedModule: './OrdinationComponent',
      componentName: 'OrdinationComponent',
      customElementName: 'ordination-artifact',
      componentId: 275,
      dynamicFormTypeId: 0,
    },
    componentDiagnoses: {
      exposedModule: './DiagnosesComponent',
      componentName: 'DiagnosesComponent',
      customElementName: 'diagnoses-artifact',
      componentId: 273,
      dynamicFormTypeId: 0,
    },
    componentAnamnesis: {
      exposedModule: './AnamnesisComponent',
      componentName: 'AnamnesisComponent',
      customElementName: 'anamnesis-artifact',
      componentId: 263,
      dynamicFormTypeId: 0,
    },
    componentMedicationReconciliation: {
      exposedModule: './MedicationReconciliationComponent',
      componentName: 'MedicationReconciliationComponent',
      customElementName: 'medication-reconciliation-artifact',
      componentId: 265,
      dynamicFormTypeId: 0,
    },
    componentManagementPlan: {
      exposedModule: './IndexManagementPlanComponent',
      componentName: 'IndexManagementPlanComponent',
      customElementName: 'management-plan-artifact',
      componentId: 278,
      dynamicFormTypeId: 0,
    },
    compFormGeneral: {
      exposedModule: './IndexFormsComponent',
      componentName: 'IndexFormsComponent',
      customElementName: 'forms-artifact',
      componentId: 0,
      dynamicFormTypeId: 50381,
    },
    compFormStandard: {
      exposedModule: './IndexFormsComponent',
      componentName: 'IndexFormsComponent',
      customElementName: 'forms-artifact',
      componentId: 0,
      dynamicFormTypeId: 50380,
    },
    compFormPhysicalExamination: {
      exposedModule: './IndexFormsComponent',
      componentName: 'IndexFormsComponent',
      customElementName: 'forms-artifact',
      componentId: 0,
      dynamicFormTypeId: 50383,
    },
    compFormVitalSigns: {
      exposedModule: './IndexVitalSignsComponent',
      componentName: 'IndexVitalSignsComponent',
      customElementName: 'vital-signs-artifact',
      componentId: 0,
      dynamicFormTypeId: 50384,
    },
    compFormRecord: {
      exposedModule: './IndexFormRecordComponent',
      componentName: 'IndexFormRecordComponent',
      customElementName: 'form-record-artifact',
      componentId: 0,
      dynamicFormTypeId: 50382,
    },
    compFormInformedConsent: {
      exposedModule: './IndexFormInformedConsentComponent',
      componentName: 'IndexFormInformedConsentComponent',
      customElementName: 'informed-consent-artifact',
      componentId: 277,
      dynamicFormTypeId: 0,
    },
  },
  mfOdontologia: {
    remoteEntryUrl: 'https://qa-v2.alehis.com/mf-odontologia/remoteEntry.json',
    componentConventions: {
      exposedModule: './Conventions',
      componentName: '',
      customElementName: '',
      componentId: 0,
      dynamicFormTypeId: 0,
    },
    componentDentalPieces: {
      exposedModule: './DentalPiecesModule',
      componentName: '',
      customElementName: '',
      componentId: 0,
      dynamicFormTypeId: 0,
    },
    componentPrescription: {
      exposedModule: './Prescription',
      componentName: 'IndexPrescriptionsComponent',
      customElementName: 'prescription-artifact',
      componentId: 276,
      dynamicFormTypeId: 0,
    },
    componentOdontogram: {
      exposedModule: './Odontogram',
      componentName: 'IndexOdontogramComponent',
      customElementName: 'odontogram-artifact',
      componentId: 269,
      dynamicFormTypeId: 0,
    },
    componentPeriodontrogram: {
      exposedModule: './Periodontrogram',
      componentName: 'IndexPeriodontrogramComponent',
      customElementName: 'periodontrogram-artifact',
      componentId: 271,
      dynamicFormTypeId: 0,
    },
    componentIndexOleary: {
      exposedModule: './IndexOleary',
      componentName: 'OlearyIndexComponent',
      customElementName: 'index-oleary-artifact',
      componentId: 270,
      dynamicFormTypeId: 0,
    },
    componentIndexCOPCEO: {
      exposedModule: './IndexCOPCEO',
      componentName: 'CopCeoIndexComponent',
      customElementName: 'cop-ceo-index-artifact',
      componentId: 272,
      dynamicFormTypeId: 0,
    },
    componentTreatmentPlan: {
      exposedModule: './TreatmentPlan',
      componentName: 'IndexTreatmentPlanComponent',
      customElementName: 'treatment-plan-artifact',
      componentId: 268,
      dynamicFormTypeId: 0,
    },
    componentProcedures: {
      exposedModule: './Procedures',
      componentName: 'IndexProceduresComponent',
      customElementName: 'procedures-artifact',
      componentId: 569,
      dynamicFormTypeId: 0,
    },
  },
  mfFinancial: {
    remoteEntryUrl: 'https://qa-v2.alehis.com/mf-financial/remoteEntry.json',
    componentSales: {
      exposedModule: './SalesModule',
      componentName: '',
      customElementName: '',
      componentId: 0,
      dynamicFormTypeId: 0,
    },
    componentReportFinancial: {
      exposedModule: './ReportFinancialModule',
      componentName: '',
      customElementName: 'report-financial-artifact',
      componentId: 0,
      dynamicFormTypeId: 0,
    },
  },
}

export const encrypt: Encrypt = {
  rsa: {
    public:
      '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwxFcTmgPp3rmNWZvnft+vYm+8Q58pGS+pgtyYJArmGlMe7B9QcB/2QSDU3zWqJt2MnulaNGImsxyJiqBCsf1iMWOjoreJdg8cB7jJLYIgM0a2AkyET2Q/B/DqUDykqQeq2rnTku9PxgAJvjg2MRQ67YYOQ0j6DAuMPH5ZL3I3oNlkCt26K+UJLAZXVd2ZgiUCovAAJvloQv08r40i9zycmOMbwfpNHp2y1vCVMCuAx8eY0HZanlB1ZsYQHZKgbmSd9VJVvsf0q/O/LPN4wpeK53IJbNeluL0/TIttmJ8s5iZwCu6+CGsg6jrtTOhKeiSict9z5CdnPqklprgcreIJwIDAQAB-----END PUBLIC KEY-----',
    private:
      '-----BEGIN PRIVATE KEY-----MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDDEVxOaA+neuY1Zm+d+369ib7xDnykZL6mC3JgkCuYaUx7sH1BwH/ZBINTfNaom3Yye6Vo0YiazHImKoEKx/WIxY6Oit4l2DxwHuMktgiAzRrYCTIRPZD8H8OpQPKSpB6raudOS70/GAAm+ODYxFDrthg5DSPoMC4w8flkvcjeg2WQK3bor5QksBldV3ZmCJQKi8AAm+WhC/TyvjSL3PJyY4xvB+k0enbLW8JUwK4DHx5jQdlqeUHVmxhAdkqBuZJ31UlW+x/Sr878s83jCl4rncgls16W4vT9Mi22YnyzmJnAK7r4IayDqOu1M6Ep6JKJy33PkJ2c+qSWmuByt4gnAgMBAAECggEAPUxuz9rGlJA72GsMxz35WXF4VcMCKxzXhlFRi4Oyl237kWDoM6nc4yMWa71urURRM9MEKzixL0fw1QqFS5CDmYvPXP7JiWX2tBsYsPgdGvCZL2tQVvecYIZQ05arw6YcVyy8bC/D1BhkL9sEuUmTzkaGPSNidbvyQAJCJ0S2YymlTk8EQokW3XsI5UWDUxuCHLwed2dVEgQUY4a/s58XvE+3nNxYOjegVRauVMXYliva6Rqo/2RJvZvbL4exv+11Mb37DkCkd77WxfpBIbEAAwIO4FEEATq80N+UBrJgczxCo7GHF6WQgBFpPBv/HmJZdtCxd/9SYzTxNAD9vqnhwQKBgQD08OQsmPTf4fR4YZ0i2LiTe//goUgAIQiilDVCtuO1FuWNmhG5GDdhJXeuhqy1cJb2pud+1Mn2EuMMsQx4F6t98ViIll7Y3w/4fNKhh+C6XkS06wK/NQxWxiQCD7dLLgrTMsvmI/2ZXsQ8Q0UO0MF8FyuMYaiHlm9l3EuslCbEZwKBgQDL4ATMdUo6XC3tyZ8iKgN1aCCFLSX1ut6abXZW7kp2XWg0qUTcB5q4D/KkBJ7whf8VQiEPddcortqRNUswj7eDPDG5lVMyC4F55QHx5v96scHwthhYTTAyqKPw0GYtbkAOMJdK71fW/CwNIizIk+sU0Ts73F3cOsXWWxCABEjGQQKBgQCmQLdvOebD63dnGkJw+47UtE6qZm4bgFB/IX/BJ6gJK2BmK5QqATDdpHPGpyyk/qXJBuKMKNxoRMuNusKO5OoG0wDXvNDl/Qm3DOper36uoPubnQRBSj10zIp2R7qOsdKxJYJWVEl2h2dEzBgchT8+/e8WGtcsKMS168AFhI2HswKBgQCpEi1IlVgqT7lzAgprHaZiniih6NAbGY5zSKWj79dmk43QZjOJuPCxBeC17nMUijsBGScrmBEHVwJA+45QRk7skWW3PsOQtAP631SelG94A6QPCCPmTpTS3hGeqmSh9lU+r0M4TIZu7g9mENpMuIZybBWQTe60rTTV0A097M+hQQKBgGvpjDidcYwVbueWG1EJBN7Z5b3YP4I/6l5AOfpGjXNCe38MWpK1bCkDtr0za6j75olPiJ6+gd2lStyF4bSicq031fG1Alg1MRhMRzRgMbwiGiL8eivCJP+qm4BngINIeSL5AIShzW2EhnIzK+kgGBdYhU5aK1gwhp7S16xax0Xl-----END PRIVATE KEY-----',
  },
}
